
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  props: { imageName: String, modalId: String },
})
export default class ImageModal extends Vue {
  public static openModal(modalId: string) {
    var modal: any = document.getElementById(modalId);
    modal.style.display = "flex";
  }

  public closeModal() {
    var modal: any = document.getElementById(this.$props.modalId);
    modal.style.display = "none";
  }

  getImgUrl(imageName: string) {
    var images = require.context("../assets/", false, /\.png$/);
    return images("./" + imageName + ".png");
  }
}
